import { ServerMessage, ServerMessagePayload } from '@common/api';
import { CommonServiceContainer } from '@common/services/CommonServiceContainer';

type MessageHandler<T extends ServerMessagePayload = ServerMessagePayload> = (payload: T) => void;

export class ClientMessageDispatchService {
  private handlers: Map<string, MessageHandler> = new Map();
  private commonServices: CommonServiceContainer;

  constructor(commonServices: CommonServiceContainer) {
    this.commonServices = commonServices;
  }

  public registerHandler<T extends ServerMessagePayload>(
    type: T['type'],
    handler: (payload: T) => void,
  ): void {
    if (this.handlers.has(type)) {
      console.warn(`Overwriting message handler for type: ${type}`);
    }
    this.handlers.set(type, handler as MessageHandler);
  }

  public processMessages(messages: ServerMessage[]): void {
    while (messages.length > 0) {
      const message = messages.shift();
      if (!message) continue;

      // Sync tick with server
      this.commonServices.eventBus.setTick(message.tick);

      // iterate through the message payloads
      message.payload.forEach((payload) => {
        const handler = this.handlers.get(payload.type);
        if (handler) {
          handler(payload);
        } else {
          console.warn('Unknown payload type:', payload);
        }
      });
    }
  }
}
